import auth from '@/libs/auth'
import features from '@/mixins/features'
export default {
  data: function () {
    return {
      libs: { auth }
    }
  },
  mixins: [features],
  methods: {
    checkLogin: auth.checkLogin
  },
  computed: {
    isAdmin: auth.isAdmin,
    isAnalytic: auth.isAnalytic,
    isLoggedIn: auth.isLoggedIn,
    isCurator: auth.isCurator,
    isResourceEditor: auth.isResourceEditor,
    isJudgeAdmin: auth.isJudgeAdmin,

    currentUser: function () {
      return this.$store.getters.currentUser
    },
    hasCurrentUser: function () {
      return this.$store.getters.hasCurrentUser
    },
    wasAdmin: auth.wasAdmin,
    userCanCreatePosts: function () {
      if (this.$isEngCom) {
        return this.isLoggedIn && (this.isAdmin || this.currentUser.canPublish)
      }
      return true
    }
  }
}
